export default "__VITE_ASSET__DYJqagPO__"